// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1awKm","tab":"ProcedureTabs_tab__203QP"};